import { render, staticRenderFns } from "./edit-virtual-artefact-text.vue?vue&type=template&id=41396c12&scoped=true&"
import script from "./edit-virtual-artefact-text.vue?vue&type=script&lang=ts&"
export * from "./edit-virtual-artefact-text.vue?vue&type=script&lang=ts&"
import style0 from "./edit-virtual-artefact-text.vue?vue&type=style&index=0&id=41396c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41396c12",
  null
  
)

export default component.exports